import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'tipoImpuestoTotal'
})
export class TipoImpuestoTotalPipe implements PipeTransform {

  transform(value: string): string {
    switch(value) {
      case '001':
        value = 'ISR';
      break
      case '002':
        value = 'IVA';
      break
      case '003':
        value = 'IEPS';
      break
    }

    return value;
  }

}
